import React from 'react';
import { Route, Switch, Redirect } from 'react-router';

import { roles } from '../Shared/utils';
import { useAppContext } from '../Context/App/Provider';


import Reporting from '../Views/Reporting';
import Realtime from '../Views/Realtime';
import Settings from '../Views/Settings';

import Group from '../Views/Admin/Group';
import Groups from '../Views/Admin/Groups';
import Accounts from '../Views/Admin/Accounts';
import Locations from '../Views/Admin/Locations';
import Scenarios from '../Views/Admin/Scenarios';
import EditScenario from '../Views/Admin/Scenarios';
import Reports from '../Views/Admin/Reports';
import Licenses from '../Views/Admin/Licenses';


export default function LoggedInRoutes() {
  const [{user}] = useAppContext();

  return (
    <Switch>
      <Route path='/reporting'>
        <Reporting/>
      </Route>

      <Route path='/realtime'>
        <Realtime/>
      </Route>

      <Route path='/settings'>
        <Settings/>
      </Route>

      {/* Requires each condition to be separate to avoid console warnings */}
      {user.roleId !== roles.user && <Route exact path={['/admin/accounts', '/admin']}>
        <Accounts/>
      </Route>}
        
      {user.roleId !== roles.user &&<Route exact path='/admin/locations'>
        <Locations/>
      </Route>}

      <Route exact path='/admin/scenarios'>
        <Scenarios />
      </Route>

      <Route exact path='/admin/scenarios/scenario/:id'>
        <EditScenario />
      </Route>

      {/* {user.roleId !== roles.user &&<Route exact path='/admin/scenarios'>
        <Scenarios/>
      </Route>}

      {user.roleId !== roles.user &&<Route exact path='/admin/scenarios/scenario/:id'>
        <EditScenario/>
      </Route>} */}

      {user.roleId !== roles.user && <Route exact path='/admin/groups'>
        {user.roleId <= roles.stAdmin ? <Groups/> : <Group/>}
      </Route>}

      {user.roleId !== roles.user &&<Route exact path='/admin/reports'>
        <Reports/>
      </Route>}

      {user.roleId !== roles.user && <Route exact path='/admin/licenses'>
        {user.roleId <= roles.stAdmin ? <Licenses /> : <Licenses />}
      </Route>}

      {/* Redirect to the home page if the route doesn't exist */}
      <Route render={() => <Redirect to="/reporting"/>}/>
    </Switch>
  );
}